import React from 'react'

const NotFound: React.FC = () => {
  return (
    <div className="wrap center">
      <h1>Erreur 401</h1>
      <p>Vous n'avez pas l'autorisation d'accéder à cette page.</p>
      <p>
        Voulez-vous retourner à la <a href="https://moncompte.howdens-cuisines.com/">page d'accueil</a>&nbsp;?
      </p>
    </div>
  )
}

export default NotFound
